module.exports = __webpack_public_path__ + "img/showFalse.85426705.png";